(function () {
  const variantCache = new Map();

  function getTranslations() {
    const el = document.getElementById('wetheme-global');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent).translations || {};
    } catch (e) {
      return {};
    }
  }

  function getPageContainer() {
    return document.getElementById('PageContainer');
  }

  async function getCheapestVariantId(handle) {
    if (variantCache.has(handle)) {
      return variantCache.get(handle);
    }

    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) {
      throw new Error(`Failed to load product: ${handle}`);
    }

    const product = await response.json();
    const availableVariants = product.variants.filter((variant) => variant.available);
    if (!availableVariants.length) {
      variantCache.set(handle, null);
      return null;
    }

    const cheapestVariant = availableVariants.reduce((cheapest, variant) => {
      return parseFloat(variant.price) < parseFloat(cheapest.price) ? variant : cheapest;
    });

    variantCache.set(handle, cheapestVariant.id);
    return cheapestVariant.id;
  }

  async function addVariantToCart(variantId) {
    const pageContainer = getPageContainer();
    const cartType = pageContainer ? pageContainer.dataset.cartType : '';
    const languageUrl = pageContainer ? pageContainer.dataset.languageUrl : '';
    const body = new URLSearchParams({
      id: String(variantId),
      quantity: '1'
    });

    if (cartType === 'drawer') {
      body.append('sections', 'cart-drawer');
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: body.toString()
    });

    if (!response.ok) {
      throw new Error('Add to cart failed');
    }

    const responseJson = await response.json();

    if (cartType === 'drawer' && window.eventBus) {
      window.eventBus.emit('update:cart:drawer', responseJson);
    }

    const languageParam = !languageUrl || languageUrl === '/' ? '' : languageUrl;
    const cartResponse = await fetch(`${languageParam}/cart?view=compare`);
    if (cartResponse.ok && window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
      const cart = await cartResponse.json();
      window.wetheme.updateCartCount(cart);
    }

    return responseJson;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.search-drawer-atc');
    if (!button || button.disabled || button.classList.contains('is-loading')) {
      return;
    }

    if (!button.closest('#SearchContainer')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (!handle) {
      return;
    }

    const translations = getTranslations();
    const addToCartLabel = translations.addToCart || button.textContent;
    const addedLabel = translations.productAdded || translations.added || 'Added';

    button.classList.add('is-loading');
    button.disabled = true;
    const defaultButtonHtml = button.innerHTML;

    try {
      const variantId = await getCheapestVariantId(handle);
      if (!variantId) {
        button.innerHTML = `<span>${translations.soldOut || 'Sold out'}</span>`;
        button.classList.add('disabled');
        return;
      }

      await addVariantToCart(variantId);
      button.classList.remove('is-loading');
      button.innerHTML = `<span>${addedLabel}</span>`;

      window.setTimeout(() => {
        button.innerHTML = defaultButtonHtml;
        button.disabled = false;
      }, 2000);
    } catch (error) {
      console.error('Search drawer add to cart failed', error);
      button.classList.remove('is-loading');
      button.disabled = false;
      button.innerHTML = defaultButtonHtml;
    }
  });
})();
